import template from './list-header.html';

const ListHeaderComponent = {
    bindings: {
        conditionalClass: '<',
        conditionalClassComparator: '<',
        headers: '<',
        onColumnClick: '&',
        sortIndex: '<',
        sortPropDisplay: '<'
    },
    template
};

export default ListHeaderComponent;



// WEBPACK FOOTER //
// ./app/common/list-header/list-header-component.js